<ms-consult-filiation-data name="consult-filiation-data" [turn]="turn" [(ngModel)]="patientData.filiationData"
  *ngIf="!readonly">
</ms-consult-filiation-data>

<ng-content></ng-content>

<ms-consult-vital-sign [patient]="patient" [turn]="turn" [readonly]="readonly"></ms-consult-vital-sign>

<ms-consult-subject name="consult-subject" [turn]="turn" [(ngModel)]="detail.subject" [readonly]="readonly">
</ms-consult-subject>

<ms-consult-disease name="consult-disease" [turn]="turn" [(ngModel)]="detail.disease" [readonly]="readonly">
</ms-consult-disease>

<ms-consult-organ [turn]="turn" [readonly]="readonly"></ms-consult-organ>

<ms-consult-examination [turn]="turn" [readonly]="readonly"></ms-consult-examination>

<ms-consult-analysis name="consult-analysis" [turn]="turn" [(ngModel)]="detail.analysis" [readonly]="readonly">
</ms-consult-analysis>

<ms-consult-additional name="consult-additional" [turn]="turn" [(ngModel)]="detail.additionalInformation"
  [readonly]="readonly">
</ms-consult-additional>

<ms-consult-treatment-plan name="consult-treatment-plan" [turn]="turn" [(ngModel)]="detail.treatmentPlan"
  [readonly]="readonly">
</ms-consult-treatment-plan>

<ms-consult-diagnostic [turn]="turn" [readonly]="readonly"></ms-consult-diagnostic>

<ms-consult-recipe [turn]="turn" [readonly]="readonly"></ms-consult-recipe>